<usb-base-modal
  [title]="title"
  [subtitle]="subtitle"
  [message]="message"
  [confirmText]="confirmText"
  [cancelText]="cancelText"
  [showCancelButton]="showCancelButton"
  [size]="size"
  [titleReverse]="titleReverse"
  [icon]="icon"
  (confirm)="onConfirm()"
  (decline)="onDecline()"
>
  <div class="seller-select-container mb-2">
    <div class="d-flex flex-column align-items-center w-100 px-4">
      <form [formGroup]="_formSelectAgency">
        <div class="d-flex flex-column w-100">
          <h2 class="seller-select-title">Elegir Agencia</h2>
          <label class="seller-select-message">Seleccione una agencia <br /> para continuar.</label>
          <div class="seller-select-select">
            <select
              name="agencyId"
              id="agencyId"
              class="form-control input-search-box seller-select-input"
              formControlName="agencyId"
              (change)="changeAgency($event.target.value);"
            >
              <option value="" disabled selected class="seller-select-placeholder">Agencia</option>
              <ng-container *ngFor="let agency of agencies">
                <option [value]="agency.id">{{ agency.name }}</option>
              </ng-container>
            </select>
            <img
              width="10"
              height="10"
              style="position: absolute; right: 1em; top: 30%"
              src="../../../../assets/img/app/little-icons/arrow-down-black.svg"
            />
          </div>
        </div>
      </form>
    </div>
  </div>
</usb-base-modal>
